import { ACCESSIBILITY_KEYS, KEYBOARD_KEYS } from "../../constants";
import { getSessionStorage, setSessionStorage } from "../../helpers/sessionStorage";

const $mainMenuItems = $(".main-menu__list__item");
const $miniCart      = $(".minicart");

const headerMainMenuAccessibility = () => {

    $mainMenuItems.each((index, menuItemElement) => {
        $(menuItemElement).on("keydown", (event) => {

            if (event.keyCode === KEYBOARD_KEYS.TAB) {
                $(menuItemElement).addClass("menu-item-hover-active");
                $(menuItemElement).find(".categories").addClass("menu-hover-active");
                $(menuItemElement).siblings().removeClass("menu-item-hover-active");
                $(menuItemElement).siblings().find(".categories").removeClass("menu-hover-active");
            }
        });
    });
};

const headerCartAccessibility = () => {
    $miniCart.on("keydown", (event) => {

        if (event.keyCode === KEYBOARD_KEYS.TAB) {
            $mainMenuItems.each((index, menuItemElement) => {
                $(menuItemElement).removeClass("menu-item-hover-active");
                $(menuItemElement).find(".categories").removeClass("menu-hover-active");
            });
        }
    });
};

const headerZoomAccessibility = () => {
    const savedZoomLevel = getSessionStorage(ACCESSIBILITY_KEYS.ZOOM_LEVEL);

    let zoomLevel = savedZoomLevel ? savedZoomLevel : 100;

    document.documentElement.style.zoom = `${zoomLevel}%`;

    const $plusZoomIcon  = $(".js-plus-zoom");
    const $minusZoomIcon = $(".js-minus-zoom");

    $plusZoomIcon.on("click", function () {
        zoomLevel += ACCESSIBILITY_KEYS.ZOOM_STEPS;

        document.documentElement.style.zoom = `${zoomLevel}%`;
        setSessionStorage(ACCESSIBILITY_KEYS.ZOOM_LEVEL, zoomLevel);
    });

    $plusZoomIcon.on("keypress", (event) => {
        if (event.keyCode === KEYBOARD_KEYS.ENTER) {
            $plusZoomIcon.trigger("click");
        }
    });

    $minusZoomIcon.on("click", function () {
        zoomLevel -= ACCESSIBILITY_KEYS.ZOOM_STEPS;

        document.documentElement.style.zoom = `${zoomLevel}%`;
        setSessionStorage(ACCESSIBILITY_KEYS.ZOOM_LEVEL, zoomLevel);
    });

    $minusZoomIcon.on("keypress", (event) => {
        if (event.keyCode === KEYBOARD_KEYS.ENTER) {
            $minusZoomIcon.trigger("click");
        }
    });
};

const initHeaderAccessibility = () => {
    headerMainMenuAccessibility();
    headerCartAccessibility();
    headerZoomAccessibility();
};

export default initHeaderAccessibility;
